/**
 * Lazy-loaded pages for better performance
 * These components are loaded only when needed
 */

import { createLazyComponent } from '../../components/LazyRoute';

// Dashboard and main pages
export const LazyDashboard = createLazyComponent(
  () => import('../../features/home/HomePage'),
  'Loading your dashboard...'
);

export const LazyLandingPage = createLazyComponent(
  () => import('../LandingPage'),
  'Loading...'
);

export const LazyJourneyPage = createLazyComponent(
  () => import('../JourneyPage'),
  'Loading journey hub...'
);

export const LazyAuthPage = createLazyComponent(
  () => import('../AuthPage'),
  'Loading authentication...'
);

// Journey and learning pages

export const LazyCourseDetail = createLazyComponent(
  () => import('../../features/courses/CourseDetail'),
  'Loading course...'
);

export const LazyJourneyPath = createLazyComponent(
  () => import('../../features/journey-practice/JourneyPathPage'),
  'Loading path...'
);

export const LazyBiteLesson = createLazyComponent(
  () => import('../../features/journey-practice/BiteLessonPage'),
  'Loading cards...'
);

export const LazyTopicPage = createLazyComponent(
  () => import('../../features/journey-practice/TopicPage'),
  'Loading topic...'
);

export const LazyLearnLesson = createLazyComponent(
  () => import('../../features/journey-practice/LearnLessonPage'),
  'Loading lesson...'
);

export const LazyPracticeHub = createLazyComponent(
  () => import('../../features/journey-practice/PracticeHubPage'),
  'Loading practice...'
);

export const LazyPracticeSession = createLazyComponent(
  () => import('../../features/journey-practice/PracticeSessionPage'),
  'Loading questions...'
);

export const LazyExam = createLazyComponent(
  () => import('../../features/journey-practice/ExamPage'),
  'Loading practice exam...'
);

export const LazyLessonDetail = createLazyComponent(
  () => import('../LessonPageModular'),
  'Loading lesson...'
);

export const LazyQuickCoursePage = createLazyComponent(
  () => import('../QuickCoursePage'),
  'Loading course...'
);

// Profile and settings
export const LazyProfileSetupPage = createLazyComponent(
  () => import('../ProfileSetupPage'),
  'Loading profile setup...'
);

export const LazyPersonalSettings = createLazyComponent(
  () => import('../PersonalSettings'),
  'Loading settings...'
);

// Library and resources
export const LazyLibrary = createLazyComponent(
  () => import('../Library'),
  'Loading library...'
);

export const LazyToolkitPage = createLazyComponent(
  () => import('../ToolkitPage'),
  'Loading toolkit...'
);

// Analytics and achievements
export const LazyAnalyticsPage = createLazyComponent(
  () => import('../AnalyticsPage'),
  'Loading analytics...'
);

export const LazyAchievementsPage = createLazyComponent(
  () => import('../AchievementsPage'),
  'Loading achievements...'
);

// Reflections and community
export const LazyReflectionsPage = createLazyComponent(
  () => import('../ReflectionsPage'),
  'Loading reflections...'
);

export const LazyChatPage = createLazyComponent(
  () => import('../ChatPage'),
  'Loading chat...'
);

// Subscription and payments
export const LazySubscriptionPage = createLazyComponent(
  () => import('../SubscriptionPage'),
  'Loading subscription...'
);

export const LazyStripeTestPage = createLazyComponent(
  () => import('../StripeTestPage'),
  'Loading payment test...'
);

// Admin and development
export const LazyAdminPage = createLazyComponent(
  () => import('../AdminPage'),
  'Loading admin panel...'
);

export const LazyContentManagementPage = createLazyComponent(
  () => import('../ContentManagementPage'),
  'Loading content management...'
);

export const LazyUserTypeTestPage = createLazyComponent(
  () => import('../UserTypeTestPage'),
  'Loading user type test...'
);

export const LazyIntentDrivenDemoPage = createLazyComponent(
  () => import('../IntentDrivenDemoPage'),
  'Loading intent-driven workspace...'
);

// Onboarding steps (lazy loaded)
export const LazyBankingCredit = createLazyComponent(
  () => import('../../features/onboarding-steps/BankingCredit'),
  'Loading banking guide...'
);

export const LazyBudgetingSaving = createLazyComponent(
  () => import('../../features/onboarding-steps/BudgetingSaving'),
  'Loading budgeting guide...'
);

export const LazyTaxSelfEmployment = createLazyComponent(
  () => import('../../features/onboarding-steps/TaxSelfEmployment'),
  'Loading tax guide...'
);

export const LazyHousingUtilities = createLazyComponent(
  () => import('../../features/onboarding-steps/HousingUtilities'),
  'Loading housing guide...'
);

export const LazyInsuranceProtection = createLazyComponent(
  () => import('../../features/onboarding-steps/InsuranceProtection'),
  'Loading insurance guide...'
);

export const LazyEducationRetirement = createLazyComponent(
  () => import('../../features/onboarding-steps/EducationRetirement'),
  'Loading education guide...'
);

export const LazyInitialOnboardingChecklist = createLazyComponent(
  () => import('../../features/onboarding-steps/InitialOnboardingChecklist'),
  'Loading checklist...'
);

export const LazyInitialDocumentSetup = createLazyComponent(
  () => import('../../features/onboarding-steps/InitialDocumentSetup'),
  'Loading document setup...'
);

export const LazySafetyEmergency = createLazyComponent(
  () => import('../../features/onboarding-steps/SafetyEmergency'),
  'Loading safety guide...'
);

export const LazyOnboarding = createLazyComponent(
  () => import('../../features/onboarding/OnboardingPage'),
  'Loading…'
);

export const LazyStarterLesson = createLazyComponent(
  () => import('../../features/onboarding/StarterLessonPage'),
  'Loading lesson…'
);

export const LazyFirstLesson = createLazyComponent(
  () => import('../../features/onboarding/FirstLessonPage'),
  'Loading lesson…'
);

export const LazyWidgetHint = createLazyComponent(
  () => import('../../features/onboarding/WidgetHintPage'),
  'Loading…'
);

export const LazyPassOffer = createLazyComponent(
  () => import('../../features/onboarding/PassOfferPage'),
  'Loading…'
);

export const LazyAccountPrompt = createLazyComponent(
  () => import('../../features/onboarding/AccountPromptPage'),
  'Loading…'
);

export const LazyWelcomeBack = createLazyComponent(
  () => import('../../features/onboarding/WelcomeBackPage'),
  'Loading…'
);
